export default {
  metaDescription: {
    id: 'landing_meta_description',
    defaultMessage:
      'Find the best deals on the refurbished {productType}. Up to 70% off compared to new ✌ Free delivery ✅ Cheap {productType} ✅ {warrantyDuration} year warranty ✅ {coolingOffDays}-day money-back guarantee',
  },

  seoTitle: {
    id: 'landing_seo_title',
    defaultMessage: '{title} - Page {pageNumber}',
  },
}
